import React from 'react';
import { string, shape } from 'prop-types';
import withUserAgent from 'containers/withUserAgent';

import './NotSupportBanner.scss';

function NotSupportBanner({ text, userAgent }) {
  const { isIE } = userAgent;
  if (!isIE) {
    return null;
  }
  return (<div className="not-support-warning">{text}</div>);
}

NotSupportBanner.propTypes = {
  text: string.isRequired,
  userAgent: shape({}).isRequired,
};

export default withUserAgent(NotSupportBanner);
